import { periodFormat } from 'utils/common';

export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      role: filter.role[0] ? filter.role : '*',
      assigneeName: filter.assigneeName[0] ? filter.assigneeName : '*',
      score: {
        from: filter.score.from ? filter.score.from : '*',
        to: filter.score.to ? filter.score.to : '*'
      },
      responseTime: {
        from: filter.responseTime.from ? filter.responseTime.from : '*',
        to: filter.responseTime.to ? filter.responseTime.to : '*'
      },
      createdAt: periodFormat(filter.createdAt)
    },

    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
